import React, { useRef, useEffect } from "react";
import cx from "classnames";
import styles from './seekInputArea.module.scss';
import { Button, FormControl, FormGroup, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import paperfliteWhiteIcon from 'images/white-flite.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSeekPrompts } from 'actions/seek';
import _ from 'lodash';
import LinesEllipsis from "react-lines-ellipsis";

export default function SeekInputArea(props) {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const prompts = useSelector((state) => _.get(state, 'seek.prompts.items') || []);
  const promptsLoading = useSelector((state) => _.get(state, 'seek.prompts.loading'));

  const [clamped, setClamped] = React.useState(false);


  useEffect(() => {
    if (!promptsLoading && _.size(prompts) === 0) {
      dispatch(fetchSeekPrompts());
    }
  }, []);

  return (
    <div
      className={cx(styles.container, props.className, {
        [styles.disableSearchBar]: props.disabled,
      })}
    >
    <div className={styles.promptsArea}>
    {promptsLoading && !props.showChats ? (
      _.map([1, 2], (item) => <div key={item} className={styles.loading}></div>)
    ) : (
    Array.isArray(prompts) && prompts.length > 0 && !props.showChats ? (
      prompts.slice(0, 3).map((prompt, index) => {
      const text = "/ " + (prompt.text || prompt);

      return (
        <div key={index} className={styles.prompt} onClick={() => props.onPromptClick(text)}>

          {clamped ? (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className={styles.toolTip} id={`tooltip-${index}`}>
                  {text}
                </Tooltip>
              }
            >
              <div>
                <LinesEllipsis
                  text={text}
                  maxLine="2"
                  ellipsis="…"
                  trimRight
                  onReflow={(r) => setClamped(r.clamped)}
                />
              </div>
            </OverlayTrigger>
          ) : (
            <LinesEllipsis
              text={text}
              maxLine="2"
              ellipsis="…"
              trimRight
              onReflow={(r) => setClamped(r.clamped)}
            />
          )}

        </div>
      );
    })
  ) : null
)}
    </div>
      <form
      >
        <FormGroup>
          <InputGroup>
            <FormControl
              as="textarea"
              style={{ resize: "none" }}
              type="text"
              value={props.value}
              ref={inputRef}
              disabled={props.disabled}
              className={styles.inputField}
              placeholder={props.placeholder}
              onChange={(e) => {
                props.onChange(e.target.value);
              }}
              onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                props.onSubmit();
              }
            }}
            />
            {!props.placeholder && (
              <div
                className={styles.placeholder}
                onClick={() => {
                  if (!props.disabled) {
                    inputRef.current.focus();
                  }
                }}
              >
                {!props.isLimitExceeded && (
                  <div className={styles.wrapper}>
                    {promptsLoading ? (
                      <div className={styles.text}>Loading...</div>
                    ) : (
                      Array.isArray(prompts) && prompts.length > 0 ? (
                        prompts.map((prompt, index) => (
                          <div key={index} className={styles.text}>{prompt.text || prompt}</div>
                        ))
                      ) : (
                        <div className={styles.text}>How can I help you today?</div>
                      )
                    )}
                  </div>
                )}
              </div>
            )}
            <Button
              disabled={props.value === "" || props.disabled}
              type="submit"
              onClick={() => props.onSubmit()}
            >
            <i className={cx("paperflite-right-arrow", styles.seekSendIcon)} />
            </Button>
          </InputGroup>
        </FormGroup>
      </form>
    </div>
  );
}